import { render, staticRenderFns } from "./l-dialog.vue?vue&type=template&id=1db836c7&scoped=true"
import script from "./l-dialog.vue?vue&type=script&lang=js"
export * from "./l-dialog.vue?vue&type=script&lang=js"
import style0 from "./l-dialog.vue?vue&type=style&index=0&id=1db836c7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db836c7",
  null
  
)

export default component.exports